import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const HypervergeShow: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
